<template>
    <div>
        <div>
            <a-button class="top_btn" type="primary" @click="()=>{  visibleForm = true; titleForm='添加' }" >添加</a-button>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" style="width: 60%">
            <span slot="status" slot-scope="text, record">
                <a-switch
                checked-children="开启"
                un-checked-children="关闭"
                @click="onChange(record)"
                :checked="text == 1 ? true : false"
                />
            </span>
            <span slot="action" slot-scope="text, record">
                <a @click="(record)=>{visibleForm = true; titleForm='编辑'; editId=text.id ; }">编辑</a>
            </span>
        </a-table>
        <filialeForm :visible="visibleForm" :title="titleForm" :editId="editId"
                  @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList()}  "/>

    </div>

</template>

<script>
    import API from "../Filiale/api";
    import filialeForm from "./components/filialeForm"
    import {changStatus,removeById,orderList} from "../../../utils/utils"
    const columns = [
        {
            title: "分公司团队",
            dataIndex: "team_name",
            ellipsis: true,
            key: "team_name"
        },
        {
            title: "客服",
            dataIndex: "kf_name",
            ellipsis: true,
            key: "kf_name"
        },
        {
            title: "QQ",
            dataIndex: "qq",
            ellipsis: true,
            key: "qq"
        },
        {
            title: "状态",
            dataIndex: "status",
            ellipsis: true,
            key: "status",
            scopedSlots: {customRender: "status"}
        },
        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: 'index',
        data() {
            return {
                // 添加、编辑弹窗
                visibleForm: false,
                titleForm: "",
                selectedRowKeys: [], // Check here to configure the default column
                loading: true,
                editId: null,
                data: [],
                columns,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/Set/Filiale"; //设置左侧导航2-2 active
        },
        components: {filialeForm},
        computed: {
        },
        methods: {
            getList(page) {
                API.administrator.GET_DATA(page||1).then(res => {
                    this.data = res.data.data.info
                    this.loading = false;
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },                                
            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                changStatus(API.administrator.CHANG_STATUS_FILALE, [Json]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
        },
        mounted() {
            this.getList()
        }

    }
</script>
